import {FOOD_SUPPORTED_COUNTRIES} from '@/lib/food-grubhub/config'
import {useCountry} from '@/lib/locale/country'

export function useIsFoodGrubhubAvailableInCurrentCountry() {
  const [country] = useCountry()
  return FOOD_SUPPORTED_COUNTRIES.includes(country)
}
